export enum OrderTypeEnum {
    Inbound = 1,
    Outbound,
    MultiStopConsignee,
    MultiStopShipper
}

export enum AccesorialBelongingEnum {
    BelongsToOrder = 1,
    BelongsToDriver,
    BelongsToStorage
}

export enum OrderStatusEnum {
    Open = 1,
    Invoiced,
    Cancelled,
    PaidFull,
    PaidPartial,
    Suspense,
    Reviewed
}

export enum NotificationTypeEnum {
    NotifyDriver,
    CancelDriverOrder
}

export enum DriverActionEnum {
    NOTIFY_DRIVER = 'NOTIFY_DRIVER',
    CANCEL_DRIVER_ORDER = 'CANCEL_DRIVER_ORDER',
    PIER_APPOINTMENT = 'PIER_APPOINTMENT'
}

export enum TrackingStateEnum {
    trackIn = 1,
    trackOut = 2
}

export enum TrackingPointTypesEnum { 
    origination, 
    stop, 
    termination 
}
